import { render, staticRenderFns } from "./InvestingProgressCircular.vue?vue&type=template&id=a8bc4070&scoped=true&"
import script from "./InvestingProgressCircular.vue?vue&type=script&lang=js&"
export * from "./InvestingProgressCircular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc4070",
  null
  
)

export default component.exports